// This functio orders targets to be shopwn in tent chat in squence [yearly, quarterly, monthly, weekly]
export const reOrderTargets = (targets) => {
  const order = ["yearly", "quarterly", "monthly", "weekly"];
  const orderedMap = new Map();

  order.forEach((key) => {
    if (key in targets) {
      orderedMap.set(key, targets[key]);
    }
  });

  return Object.fromEntries(orderedMap);
};
